import ProgressBarComponent from '../components/ProgressBar/viewer/ProgressBar';


const ProgressBar = {
  component: ProgressBarComponent
};


export const components = {
  ['ProgressBar']: ProgressBar
};

